import {
  CIVILCONTRACT_LOADING,
  GET_CIVILCONTRACT,
  GET_CIVILCONTRACT_SUCCESS,
  GET_CIVILCONTRACT_FAIL,
  ADD_CIVILCONTRACT_SUCCESS,
  ADD_CIVILCONTRACT_FAIL,
  DELETE_CIVILCONTRACT_SUCCESS,
  DELETE_CIVILCONTRACT_FAIL,
  UPDATE_CIVILCONTRACT_SUCCESS,
  UPDATE_CIVILCONTRACT_FAIL,
  CIVILCONTRACT_RESET
} from "./actionType";

const INIT_STATE = {
  civilContracts: [],
  error: {},
};

const CivilContract = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CIVILCONTRACT_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CIVILCONTRACT:
          return {
            ...state,
            civilContracts: action.payload.data,
            isCivilContractCreated: false,
            isCivilContractSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_CIVILCONTRACT_FAIL:
      switch (action.payload.actionType) {
        case GET_CIVILCONTRACT_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isCivilContractCreated: false,
            isCivilContractSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_CIVILCONTRACT: {
      return {
        ...state,
        isCivilContractCreated: false,
        loading: true,
      };
    }

    case CIVILCONTRACT_LOADING: {
      return {
        ...state,
        isCivilContractCreated: false,
        loading: true,
      };
    }

    case ADD_CIVILCONTRACT_SUCCESS:
      return {
        ...state,
        isCivilContractCreated: true,
        loading: false,
        civilContracts: [action.payload.data, ...state.civilContracts],
      };

    case ADD_CIVILCONTRACT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CIVILCONTRACT_SUCCESS:
      return {
        ...state,
        loading: false,
        civilContracts: state.civilContracts.filter(
          civilCivilContract => civilCivilContract.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_CIVILCONTRACT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_CIVILCONTRACT_SUCCESS:
      return {
        ...state,
        loading: false,
        civilContracts: state.civilContracts.map(civilCivilContract =>
          civilCivilContract.id.toString() === action.payload.data.id.toString() ? { ...civilCivilContract, ...action.payload.data } : civilCivilContract
        ),
      };

    case UPDATE_CIVILCONTRACT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CIVILCONTRACT_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default CivilContract;